import { toast as sonnerToast } from 'sonner';
import { ApiError } from './api/client.js';

/**
 * Aide de toast — `02` §0 : « toast de succès ou d'erreur avec le message
 * exact ». N'invente jamais de texte : le message vient de l'appelant (le
 * plus souvent `ActionResult.message` renvoyé par l'API) ou, pour une erreur,
 * de `ApiError.message` (déjà en français courant, `04` §6).
 */
export interface ToastAction {
  label: string;
  onClick: () => void;
}

export const toast = {
  /**
   * Avec `action` (« Télécharger »…), le toast reste affiché jusqu'à sa
   * fermeture : on ne retire pas un bouton sous le pointeur (WCAG 2.2.1).
   * Renvoie l'identifiant du toast, pour le fermer (`dismiss`) quand son
   * action n'a plus de sens (page quittée).
   */
  success(message: string, options?: { action?: ToastAction }): string | number {
    const action = options?.action;
    if (action === undefined) {
      return sonnerToast.success(message);
    }
    return sonnerToast.success(message, {
      duration: Number.POSITIVE_INFINITY,
      action: { label: action.label, onClick: action.onClick },
    });
  },
  error(message: string): void {
    sonnerToast.error(message);
  },
  dismiss(id: string | number): void {
    sonnerToast.dismiss(id);
  },
  fromError(error: unknown, fallback = 'Une erreur technique est survenue.'): void {
    sonnerToast.error(error instanceof ApiError ? error.message : fallback);
  },
};
